import React from 'react';
import TodayTimeline from '../components/home/TodayTimeline';

const EntriesPage = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 dark:text-white">
          Your entries
        </h1>
        <p className="mt-2 text-base text-gray-600 dark:text-gray-400">
          Everything you've logged, so you can check it landed right.
        </p>
      </div>
      <TodayTimeline />
    </div>
  );
};

export default EntriesPage;
